import styled from 'styled-components'
const FooterWrapper = styled.div`
  position: absolute;
  bottom: 4vh;
  left: 50%;
  color: #fff;
  letter-spacing: 3px;
  font-weight: 700;
  white-space: nowrap;
  transform: translateX(-50%);
  img {
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin: 0 5px;
  }
  span {
    font-size: 12px;
  }
  a {
    margin: 0 2px;
    color: white;
    font-size: 12px;
  }
`

const MenuWrapper = styled.div``

export default FooterWrapper
